import styled, { css } from 'styled-components'

export const FormHeader = styled.div`
  margin-bottom: 3rem;
  position: relative;
`

export const FormSeparator = styled.div`
  background-color: ${({ theme }) => theme.border};
  height: 1px;
  margin: 3rem 0;
`

export const FormActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const FormFieldWrapper = styled.div`
  margin-bottom: 2rem;
`

export const FieldLabel = styled.label`
  color: ${({ theme }) => theme.text};
  margin-bottom: 5px;
`

const BaseTextStyle = css`
  padding-top: 5px;
  font-size: 1.2rem;
  font-weight: 400;
`

export const FieldError = styled.p`
  ${BaseTextStyle}
  color: ${({ theme }) => theme.error};
`

export const FieldWarning = styled.p`
  ${BaseTextStyle}
  color: ${({ theme }) => theme.warning};
`

export const FieldHint = styled.p`
  ${BaseTextStyle}
  font-style: italic;
  padding-top: 0px;
  color: ${({ theme }) => theme.text};
`

export const InlineFieldHint = styled.span`
  font-style: italic;
`

export const FormSpacer = styled.div`
  height: 15px;
`



// WEBPACK FOOTER //
// ./src/Components/FormElements/styles.js